import axios from "axios";

export default {
  async getSudoku(input: string[][]) {
    const res = await axios.post("/api/sudoku", {input: input});
    return res.data;
  }
}
